export default __webpack_public_path__ + "static/media/slide2.51fe3f26.png";